import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dark" }
const _hoisted_2 = { class: "bg-white antialiased dark:bg-zinc-900" }
const _hoisted_3 = { class: "min-h-screen lg:ml-72 xl:ml-80" }
const _hoisted_4 = { class: "contents lg:pointer-events-none lg:fixed lg:inset-0 lg:z-40 lg:flex" }
const _hoisted_5 = { class: "contents lg:pointer-events-auto lg:block lg:w-72 lg:overflow-y-auto lg:border-r lg:border-zinc-900/10 lg:px-6 lg:pt-4 lg:pb-8 lg:dark:border-white/10 xl:w-80" }
const _hoisted_6 = { class: "hidden lg:flex dark:text-zinc-400 text-white opacity-80 hover:opacity-100" }
const _hoisted_7 = { class: "relative px-4 pt-14 sm:px-6 lg:px-8" }
const _hoisted_8 = { class: "py-16" }
const _hoisted_9 = { class: "prose dark:prose-invert" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OutLink = _resolveComponent("OutLink")!
  const _component_DocsHeader = _resolveComponent("DocsHeader")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_Grid = _resolveComponent("Grid")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_SearchComboBox = _resolveComponent("SearchComboBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("header", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_OutLink, {
                  topClass: "inline-block",
                  imageClass: "h-5 inline-block rounded-full mr-2",
                  labelClass: "inline-block align-middle leading-none"
                })
              ]),
              _createVNode(_component_DocsHeader),
              _createVNode(_component_Sidebar)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("main", _hoisted_8, [
              _createElementVNode("article", _hoisted_9, [
                (_ctx.gridDisplayed)
                  ? (_openBlock(), _createBlock(_component_Grid, { key: 0 }))
                  : _createCommentVNode("v-if", true),
                _createVNode(_component_router_view),
                _createVNode(_component_Footer)
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.searchDisplayed)
      ? (_openBlock(), _createBlock(_component_SearchComboBox, { key: 0 }))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}